export default "__VITE_ASSET__27iLklvU__"